<template>
    <el-scrollbar class="sidebar" :class="collapsed ? 'sidebar-close' : ''">
      <el-menu router :default-active="activeMenu" :collapse="isCollapse" :unique-opened="true" :collapse-transition="false" mode="vertical"  @select="handleSelect">
        <menu-item v-for="item in routes" :key="item.path" :param="item" :base-path="item.path" />
      </el-menu>
    </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuItem from './MenuItem'
import sessionStorage from '@utils/store/sessionStorage'

export default {
	components: { MenuItem },
	name: 'sidebar',
	computed: {
		...mapGetters(['routes', 'sidebar']),
		isCollapse() {
			return !this.sidebar.opened
		}
	},
	data: function() {
		return {
			collapsed: false
		}
	},
	methods: {
		collapse: function() {
			this.collapsed = !this.collapsed
			this.$store.commit('TOGGLE_SIDEBAR')
		},
		handleSelect(key, keyPath) {
			sessionStorage.remove('pagelist') //清除路由分页缓存
		}
	}
}
</script>
